'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _constants = require('../../constants');

var _DropdownFilter = require('./DropdownFilter');

var _DropdownFilter2 = _interopRequireDefault(_DropdownFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var REPRESENTATIVES_UNASSIGNED = _constants.AppConstants.REPRESENTATIVES_UNASSIGNED;
var RepresentativeDropdownFilter = (_dec = (0, _mobxReact.inject)('FunderStore', 'SessionStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(RepresentativeDropdownFilter, _Component);

  function RepresentativeDropdownFilter() {
    _classCallCheck(this, RepresentativeDropdownFilter);

    return _possibleConstructorReturn(this, (RepresentativeDropdownFilter.__proto__ || Object.getPrototypeOf(RepresentativeDropdownFilter)).apply(this, arguments));
  }

  _createClass(RepresentativeDropdownFilter, [{
    key: 'onFilterChange',
    value: function onFilterChange(option) {
      var onFilterChange = this.props.onFilterChange,
          representative = option.representative,
          filterParams = {};


      if (representative) {
        if (representative === REPRESENTATIVES_UNASSIGNED) {
          filterParams.is_unassigned = true;
        } else {
          filterParams.representative = representative;
        }
      }

      onFilterChange(filterParams);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          loggedInUserLabel = _props.loggedInUserLabel,
          selectedRepresentative = _props.selectedRepresentative,
          showUnassigned = _props.showUnassigned,
          showAll = _props.showAll,
          FunderStore = _props.FunderStore,
          SessionStore = _props.SessionStore,
          userId = (0, _get3.default)(SessionStore.user, 'id'),
          representatives = (0, _mobx.toJS)(FunderStore.representatives) || [];


      if (showUnassigned) {
        representatives.unshift({ id: REPRESENTATIVES_UNASSIGNED, name: 'Unassigned' });
      }

      if (showAll) {
        representatives.unshift({ id: null, name: 'All' });
      }

      if (loggedInUserLabel) {
        var userIdx = representatives.findIndex(function (rep) {
          return rep.id === userId;
        });
        if (userIdx !== -1) {
          representatives.splice(userIdx, 1);
          representatives.unshift({ id: userId, name: loggedInUserLabel });
        }
      }

      return _react2.default.createElement(
        'div',
        { className: 'wrapper-case-owner wrapper green-dropdowns' },
        _react2.default.createElement(
          'h3',
          null,
          'Case owner:'
        ),
        _react2.default.createElement(_DropdownFilter2.default, {
          filterName: 'representative',
          onFilterChange: this.onFilterChange,
          options: representatives,
          optionName: 'name',
          selectedId: selectedRepresentative,
          showNullOption: false
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return RepresentativeDropdownFilter;
}(_react.Component), _class2.defaultProps = {
  loggedInUserLabel: null,
  selectedRepresentative: null,
  showUnassigned: false
}, _class2.propTypes = {
  FunderStore: _propTypes2.default.object,
  loggedInUserLabel: _propTypes2.default.string,
  onFilterChange: _propTypes2.default.func.isRequired,
  selectedRepresentative: _propTypes2.default.string,
  SessionStore: _propTypes2.default.object,
  showAll: _propTypes2.default.bool,
  showUnassigned: _propTypes2.default.bool
}, _temp)) || _class) || _class) || _class);
var _default = RepresentativeDropdownFilter;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(REPRESENTATIVES_UNASSIGNED, 'REPRESENTATIVES_UNASSIGNED', '/app/src/components/common/RepresentativeDropdownFilter.js');
  reactHotLoader.register(RepresentativeDropdownFilter, 'RepresentativeDropdownFilter', '/app/src/components/common/RepresentativeDropdownFilter.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common/RepresentativeDropdownFilter.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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